// src/firebase.js
import { initializeApp } from 'firebase/app';
import { getFirestore, doc, getDoc, setDoc, updateDoc, increment } from 'firebase/firestore';

// Your Firebase config from Step 3
const firebaseConfig = {
  apiKey: "AIzaSyDO7el1X02HwCTOgu4V97_XxzUXqJbpBxA",
  authDomain: "srichems-like.firebaseapp.com",
  projectId: "srichems-like",
  storageBucket: "srichems-like.firebasestorage.app",
  messagingSenderId: "478182850570",
  appId: "1:478182850570:web:dc01b959df47e826519ff3",
  measurementId: "G-6WQYVHTV5X"
};

// Initialize Firebase
const app = initializeApp(firebaseConfig);
const db = getFirestore(app);

export { db, doc, getDoc, setDoc, updateDoc, increment };